/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesUpdateAgentSchedule } from "../../funcs/agentSchedulesUpdateAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesUpdateAgentSchedule: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-update-agent-schedule",
  description: `Update an agent schedule`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesUpdateAgentSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
